// OTPロック解除時刻(サーバーの locked_until, ISO文字列)を「◯時◯分」表記に整形する。
// companyOtpVerification・managementLogin・loginModalの3箇所で同じ文言を使うため共通化している。
export const formatLockedUntil = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getHours()}時${String(date.getMinutes()).padStart(2, '0')}分`;
};

export const buildOtpLockedMessage = (iso: string | null | undefined): string =>
  `入力回数の上限に達しました。${formatLockedUntil(iso)}以降にもう一度お試しください。`;
